// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rJMu2","type":"styles_type__1Z829","choices":"styles_choices__LQ_dP"};